module.exports = __webpack_public_path__ + "static/media/love-potion.1701359c.png";